import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=e6226a96&scoped=true&"
import script from "./LoginHistory.vue?vue&type=script&lang=js&"
export * from "./LoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6226a96",
  null
  
)

export default component.exports